import Vue from 'vue'
import store from '@/store'
import api from '@/api/Api'
import $ from 'jquery'
import common from './common'
import md5 from 'js-md5'
import misc from './misc'
import is from './is'

export const globalOptions = {
    types: [],
    order: 'desc',
    total: 25,
    npk: '',
    forceSync: '',
    f: {
        id: '',
        name: '',
        ratingSystem: '',
        status: ''
    }
}

export const _getUrl = (types, cf, nf) => {
    if($.isArray(types))
        types = types.join(':')
    
    return {
        path: '/Projects/getList/'+types,
        data: $.extend(true, {}, globalOptions, {
            npk: cf.npk,
            lastSync: cf.lastSync,
            f: cf.filters
        }, nf || {})
    }
}

export const _getPayload = (list, info, r) => {
    let wait = $.Deferred()
    
    let payload = {
        loaded: 0,
        npk: r.data.npk || '',
        lastSync: r.data.lastSync || '',
        filters: info.data.f,
        hash: '',
        data: r.data.result
    }
    
    let f = r.data.filters
    
    $.each(payload.filters, (k, v) => {
        if(f[v])
            payload.filters[v] = f[v]
    })
    
    if(payload.filters.id)
        payload.loaded = 1
    else
        payload.loaded = 2
    
    payload.hash = md5($.param(payload.filters))
    
    bootApp().then(
        (r) => {
            return wait.resolve(payload).promise()
        },
        (r) => {
            return wait.reject(payload).promise()
        }
    )
    
    return wait.promise()
}

export const bootApp = () => {
    let wait = $.Deferred()
    
    if(is.ready())
        return wait.resolve().promise()
    
    Promise.all([
        api.get('/Common/getCountriesAndStates').then((r) => {
            store.dispatch('peer/countriesInfo', r.data)
        }),
        
        api.get('/Common/getInfo').then((r) => {
            store.dispatch('peer/peerInfo', r.data)
        })
    ]).then((r) => {
        return wait.resolve().promise()
    }, (r) => {
        return wait.reject(r).promise()
    })
    
    return wait.promise()
}

export const address = (p) => {
    let out = ''
    
    if(!p.address)
        return out
    
    if(p.address.city)
        out += p.address.city
    
    if(!p.address.country)
        return out
    
    if(p.address.state)
        out += ', '+common.getStateName(p.address.country, p.address.state)
    
    out += ', '+common.getCountryName(p.address.country)
    
    return out
}

// Call only once navigated from lists page
export const getAccessed = () => {
    let wait = $.Deferred()
    
    let path = Vue.router.history.current.path
    path = path.replace(/^\//, '').replace(/\/$/, '')
    path = path.split('/')
    
    let base = path.splice(0, 1)[0]
    
    if(!path[1]) {
        Vue.router.push({
            path: '/'+base
        })
        
        return wait.reject(false).promise()
    }
    
    let id = path.splice(0, 1)[0]
    
    let data = getLists(true, base).data['I'+id]
    
    if(data)
        return wait.resolve(data).promise()
    
    misc.blockScreen('Loading '+base+'...')
    
    getLists({
        f: {
            id: id
        }
    }, base).then(
        (r) => {
            misc.releaseScreen()
            
            if(r.data[0])
                return wait.resolve(r.data[0]).promise()
            
            store.dispatch('peer/notifyPending', {
                type: 'E',
                message: common.programName()+' details not found!',
                title: 'Not Found'
            })
            
            Vue.router.push({
                path: '/'+base
            })
            
            return wait.reject(false).promise()
        },
        (r) => {
            misc.releaseScreen()
            misc.notify('E', api.getError(r))
            return wait.reject(false).promise()
        }
    )
    
    return wait.promise()
}

export const getMiniInfo = (id, program) => {
    let wait = $.Deferred()
    
    let d = getLists(true, program)
    
    if(typeof d.data['I'+id] != 'undefined')
        return wait.resolve(d.data['I'+id]).promise()
    
    misc.blockScreen('Searching '+common.programName()+' ID... please wait.')
    getLists({
        f: {
            id: id
        }
    }, program).then(
        (res) => {
            if(res.data.length)
                return wait.resolve(res.data[0]).promise()
            else
                return wait.reject().promise()
        },
        () => {
            return wait.reject().promise()
        }
    ).always(() => {
        misc.releaseScreen()
    })
    
    return wait.promise()
}

export const resetList = (program) => {
    if(program === 'campus')
        program = 'campuses'
    else if(program === 'utility')
        program = 'utilities'
    else if(program === 'transit')
        program = 'transits'
    
    store.dispatch('lists/reset', program)
}

export const programCode = (program) => {
    if(program === 'campus')
        program = 'campuses'
    else if(program === 'utility')
        program = 'utilities'
    else if(program === 'transit')
        program = 'transits'
    
    let typeCode = {
        campuses: 'PCA',
        utilities: 'PUT',
        transits: 'PTR'
    }
    
    return {
        program: program,
        code: typeCode[program]
    }
}

export const getLists = (f, program) => {
    let pinfo = programCode(program)
    
    program = pinfo.program
    
    let list = store.getters['lists/'+program]
    
    if(f === true)
        return list
    
    let wait = $.Deferred()
    
    let info = _getUrl(pinfo.code, list, f)
    
    api.get(info.path, info.data).then(
        (r) => {
            _getPayload(list, info, r).then((payload) => {
                store.dispatch('lists/'+program, payload)
                return wait.resolve(payload).promise()
            }, (r) => {
                return wait.reject(r).promise()
            })
        },
        (r) => {
            return wait.reject(r).promise()
        }
    )
    
    return wait.promise()
}

export default {
    globalOptions, bootApp,
    address, getAccessed, programCode,
    resetList, getLists, getMiniInfo
}
